// Play rating thresholds. 4.4 is roughly where a listing stops losing installs
// to the star row; below 4.0 the store badge reads as a warning.
const GOOD = 4.4;
const OK = 4.0;

export type ScoreTone = 'good' | 'ok' | 'bad';

export function scoreTone(score: number): ScoreTone {
  if (score >= GOOD) return 'good';
  if (score >= OK) return 'ok';
  return 'bad';
}

export function formatAgo(ts: number, now: number = Date.now()): string {
  const mins = Math.floor((now - ts) / 60_000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}
